export default {
    methods: {
        mixin_destroyCollections()
        {
            for ( let key in this._data ) {
                this.mixin_destroyCollection(this._data[key]);
            }
        },

        mixin_destroyCollection(collection, level = 0)
        {
            if ( ! collection || level > 3) {
                return;
            }

            if ( typeof collection.isCollection === 'function' && collection.isCollection() ) {
                console.log('Destroying collection', collection);
                collection.destroy();
                return;
            }

            if ( typeof collection === 'object' ) {
                for ( let key in collection ) {
                    this.mixin_destroyCollection(collection[key], level++);
                }
            }
        },

        mixin_destroyModels()
        {
            for ( let key in this._data ) {
                this.mixin_destroyModel(this._data[key]);
            }
        },

        mixin_destroyModel(model, level = 0)
        {
            if ( ! model || level > 3) {
                return;
            }

            if ( typeof model.isModel === 'function' && model.isModel() ) {
                console.log('Destroying model', model);
                model.destroy();
                return;
            }

            if ( typeof model === 'object' ) {
                for ( let key in model ) {
                    this.mixin_destroyModel(model[key], level++);
                }
            }
        }
    },
    beforeDestroy() {
        this.mixin_destroyModels();
        this.mixin_destroyCollections();
    }
}